import React from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import {Helmet} from 'react-helmet'
import Loadable from '@loadable/component'
import './Wrapper.scss'

const LoadablePopup = Loadable(() => import('../Popup/Popup'))
const LoadableBanner = Loadable(() => import('../Popup/Banner'))

export default function Wrapper({children, className, menus, seo, location}) {
	return(
		<>
			<Helmet htmlAttributes={{lang: 'nb-no'}}>
				<title>{seo.siteTitle}</title>
				<meta name="description" content={seo.siteDescription} />
				<meta property="og:title" content={seo.siteTitle} />
				<meta property="og:url" content={`${seo.siteUrl}${seo.pageUrl}`} />
				<meta property="og:og:description" content={seo.siteDescription} />
				<meta property="og:type" content="" />
				<script type="text/javascript" id="hs-script-loader" async defer src="//js-eu1.hs-scripts.com/25129051.js" />
				{ seo.image && <meta property="og:image" content={`${seo.siteUrl}${seo.image.src}`} /> }
				{ seo.image && <meta property="og:image:width" content={seo.image.width} /> }
				{ seo.image && <meta property="og:image:height" content={seo.image.height} /> }
			</Helmet>
			<div className="bgTop" />
			<Header menus={menus} />
			{ location && location.pathname === '/' && <LoadablePopup /> }
			{ location && location.pathname === '/prov-gratis/' && <LoadableBanner /> }
			<main className={className}>
				{children}
			</main>
			<Footer menus={menus} />
		</>
	)
}